import {Confetti} from '../../../../uikit/Confetti';
import {View} from '../../../../uikit/View';

export const AlertConfetti = () => (
  <View
    style={{
      bottom: 0,
      left: 0,
      overflow: 'hidden',
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 5,
    }}
  >
    <Confetti />
  </View>
);
